import { AnalysisService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';
import { SUPPRESS_ERROR_NOTIFICATION_HEADER } from '@/lib/api/interceptors/problem-details.interceptor';
import type { IqDataSource, IqDataSourceConnection } from '../model/types';

export const setDataSourceEnabled = async (
  source: IqDataSource,
  enabled: boolean,
): Promise<IqDataSourceConnection> => {
  const response = await AnalysisService.updateDataSource({
    client: inferenceHttp,
    path: { source },
    body: { enabled },
    throwOnError: true,
    // The caller toasts its own message; without this the interceptor stacks a second one.
    // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
    headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' } as never,
  });

  return response.data;
};

/**
 * The sample spreadsheet, as a blob the caller saves. Fetched rather than linked because the
 * endpoint is bearer-authenticated, so a plain anchor would 401.
 */
export const downloadDataSourceTemplate = async (source: IqDataSource): Promise<Blob> => {
  const response = await AnalysisService.downloadDataSourceTemplate({
    client: inferenceHttp,
    path: { source },
    responseType: 'blob',
    throwOnError: true,
    // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
    headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' } as never,
  });

  return response.data as Blob;
};
